import React from 'react';
import { Grid } from '@material-ui/core';
import './Shop.scss';

const Step = ({ number, icon, children }) => {

  return (
    <Grid container justify="space-between" className="step-box" spacing={2}>
      <Grid item xs={3}>
        <img src={icon} className="step-icon" />
      </Grid>
      <Grid item xs={9} className="label">
        <div className="number">{number}.</div>
        {children}
      </Grid>
    </Grid>
  );
};

export default Step;
